<template>
  <b-modal
    ref="modal"
    :title="title"
    modal-class="spso-modal"
    hide-header-close
    hide-footer
    centered
    size="lg"
    @show="onShow"
    @hide="onHide"
  >
    <v-form @submit.prevent="submit">
      <div class="v-application spso-modal__body pt-4">
        <div class="input-block input-block_white">
          <label class="input-block__label">
            {{ $t('common.part_group') }}
          </label>
          <!-- item-value="guid" -->
          <v-autocomplete
            v-model="partGroup"
            :items="partGroups"
            item-text="name"
            return-object
            :placeholder="$t('common.type_to_search')"
            :search-input.sync="search"
            :loading="loading"
            :menu-props="{ maxHeight: 150 }"
            cache-items
            hide-no-data
            solo
            :rules="[rules.required]"
          />
        </div>
      </div>
      <div class="v-application d-flex">
        <v-btn
          color="primary"
          class="mr-4 flex-grow-1"
          outlined
          large
          type="submit"
          :disabled="submitDisabled || loading"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ $t('common.add') }}
        </v-btn>
        <v-btn
          class="flex-grow-1"
          outlined
          large
          @click="$refs.modal.hide()"
        >
          {{ $t('common.cancel') }}
        </v-btn>
      </div>
    </v-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash.debounce';

export default {
  name: 'PartGroupModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    supplier: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      search: null,
      rules: {
        required: (value) => Boolean(value) || this.$t('validation.required'),
      },
      partGroup: null,
      partGroups: [],
    };
  },
  computed: {
    ...mapState(['user']),
    title() {
      return this.$t('views.profile.adding_part_group');
    },
    submitDisabled() {
      return !this.partGroup;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.$refs.modal.show();
      } else {
        this.$emit('input', false);
        this.$refs.modal.hide();
      }
    },
    search(val) {
      if (!val || val.length === 0) {
        this.partGroups = [];
        return;
      }

      if (this.partGroup && val === this.partGroup.name) {
        this.partGroups = [];
        return;
      }

      this.debouncedSearch(val);
    },
  },
  methods: {
    clearPage() {
      this.partGroup = null;
      this.partGroups = [];
      this.loading = false;
      this.search = null;
    },
    debouncedSearch: debounce(async function s(str) {
      this.loading = true;

      const params = {
        search: str,
        searchFields: 'name',
        limit: 10,
      };

      try {
        const { data = {} } = await this.$http.get('part-groups', { params });
        this.partGroups = data.rows || [];
      } catch (err) {
        this.$http.mockApiError(err);
      }

      this.loading = false;
    }, 350),
    async onShow() {
      this.clearPage();
    },
    async submit() {
      this.loading = true;

      const params = {
        asdb: this.supplier,
        groupGuid: this.partGroup.guid,
      };

      try {
        await this.$http.put('/supplier.part-groups/put-by-guid', null, { params });
        this.$emit('submit');
      } catch (err) {
        this.$http.mockApiError(err);
      }

      this.loading = false;
    },
    async onHide() {
      this.clearPage();
      this.$emit('input', false);
    },
  },
};
</script>
